import React from "react";

const Summary = (props) => {
    const {
        formattedSubtotal,
        formattedShipping,
        formattedTotal,
        shippingAmount = 0,
        onProccedPay,
        currencySymbol = "",
    } = props;

    return (
        <div className="cart-paydetail w-100">
            <div className="order-total d-flex justify-content-center align-items-center">
                <span className="main-total fw-bold">Order Summary</span>
            </div>
            <div className="payment-detail">
                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="subtotal">Subtotal</span>
                    <span className="amount">{currencySymbol} {formattedSubtotal}</span>
                </div>

                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="shipping">Shipping (Standard)</span>
                    <span className="amount">
                        {Number(shippingAmount || 0) > 0
                            ? `${currencySymbol} ${formattedShipping}`
                            : "Free"}
                    </span>
                </div>
            </div>
            <div className="order-total d-flex justify-content-between align-items-center pt-2">
                <span className="main-total fw-bold">Total Cost </span>
                <span className="amount">{currencySymbol} {formattedTotal}</span>
            </div>

            <div className="checkout mt-md-2 pt-2">
                <button className="" onClick={onProccedPay}>
                    Checkout
                </button>
            </div>
        </div>

    )
}

export default Summary;
